import { useState } from "react";
import axios from "axios";

import { ADMIN_SERVER_API } from "../AdminConstants";
import useAuth from "./useAuth";
import { message } from "antd";

export default function useAdminHttp() {
  const { setIsAdmin, setAdminToolAccountUserRole } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [serverError, setServerError] = useState(null);
  const fetchData = async (url, method, body) => {
    const headerJson = {
      "Content-Type": "text/plain",
    };
    setIsLoading(true);
    try {
      const resp = await axios({
        method: method,
        withCredentials: true,
        headers: headerJson,
        url: ADMIN_SERVER_API + url,
        data: body,
      });

      // console.log("HTTP RESP >>>>>>> " + data);
      setApiData(resp);
      return resp;
    } catch (error) {
      if (error.response?.status >= 400) {
        message.error(`Request error: ${error.response?.status} ${error.response?.statusText || ''}`);
        if (error.response?.status === 401) {
          setIsAdmin(false);
          setAdminToolAccountUserRole(0);
        }
      }
      setServerError(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, apiData, serverError, fetchData };
}
